import type { AxiosError, AxiosRequestConfig } from '@ori/axios';
import { axios } from '@ori/axios';

import { ApiError } from '../models/ApiError';

export async function fetcher<T>(url: string, options?: AxiosRequestConfig): Promise<T> {
  return axios
    .get<T>(url, options)
    .then(({ data: result }) => result)
    .catch((error: AxiosError<T>) => {
      throw new ApiError(error.message, error);
    });
}
